<mat-form-field appearance="outline" [class]="getPanelClasses()">
  <mat-label>(C) Carteira / (G) Grupo de Carteiras</mat-label>
  <mat-progress-bar mode="indeterminate" [class.show]="loading" [class.hide]="!loading"></mat-progress-bar>
  <input
    matInput
    type="text"
    [placeholder]=""
    aria-label="Ativo"
    [required]="schema.required"
    [formControl]="formControl"
    [matAutocomplete]="auto" />
  <mat-autocomplete
    class="carteira-autocomplete"
    #auto="matAutocomplete"
    (optionSelected)="onOptionSelected($event)"
    (optionActivated)="onOptionActivated($event)">
    <mat-option
      class="carteira-autocomplete__item"
      *ngFor="let option of $filteredOptions | async"
      [value]="getTitle(option)"
      [matBadge]="getId(option).indexOf('|GRUPO') !== -1 ? 'G' : 'C'"
      matBadgeOverlap="true"
      [matBadgeColor]="getId(option).indexOf('|GRUPO') !== -1 ? 'accent' : 'primary'">
      {{ option.descricao }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
